<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept type="search" label="부서" name="deptCd" v-model="searchParam.deptCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            label="지정년도"
            type="year"
            name="year"
            v-model="searchParam.year"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 판정 -->
          <c-select
            type="search"
            codeGroupCd="CHECK_UP_DICISION_CD"
            codeAttrVal1="Y"
            itemText="codeName"
            itemValue="code"
            label="판정"
            name="judgmentCd"
            v-model="searchParam.judgmentCd"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <c-table
          ref="table"
          title="유소견자 사후관리 대상 목록"
          tableId="table"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          :columnSetting="false"
          :editable="editable"
          :checkClickFlag="false"
          selection="multiple"
          rowKey="suspectId"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- <c-btn label="추가" icon="add" @btnClicked="addSuspect" /> -->
              <c-btn label="검색" icon="search" @btnClicked="getList" />
              <c-btn v-if="editable && grid.data.length > 0" label="삭제" icon="remove" @btnClicked="removeSuspect" />
              <c-btn
                v-if="editable && grid.data.length > 0"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="grid.data"
                :mappingType="mappingType"
                label="해제일 저장"
                icon="save"
                @beforeAction="saveSuspect"
                @btnCallback="saveCallback" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
        <c-table
          ref="table2"
          title="유소견자별 건강상담 목록"
          tableId="table2"
          :columns="grid2.columns"
          :gridHeight="grid2.height"
          :data="grid2.data"
          :columnSetting="false"
          :filtering="false"
          @linkClick="detailPopup"
        >
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable && isRegister" label="등록" icon="add" @btnClicked="detailPopup" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'suspect-user',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'checkupName',
            field: 'checkupName',
            label: '건강검진계획명',
            align: 'left',
            style: 'width:200px',
            sortable: false,
          },
          {
            name: 'deptName',
            field: 'deptName',
            label: '부서',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'userName',
            field: 'userName',
            label: '대상자',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'judgmentNames',
            field: 'judgmentNames',
            label: '판정(질환)',
            align: 'left',
            style: 'width:300px',
            sortable: false,
          },
          {
            name: 'appointDate',
            field: 'appointDate',
            label: '지정일',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            setHeader: true,
            name: 'releaseDate',
            field: 'releaseDate',
            label: '해제일',
            align: 'center',
            type: 'date',
            style: 'width:110px',
            sortable: false,
          },
        ],
        data: [],
      },
      grid2: {
        columns: [
          {
            name: 'consultTypeName',
            field: 'consultTypeName',
            label: '상담구분',
            style: 'width: 100px',
            align: 'center',
            sortable: false,
          },
          {
            name: 'consultDate',
            field: 'consultDate',
            label: '상담일',
            align: 'center',
            style: 'width: 100px',
            sortable: true,
            type: 'link',
          },
        ],
        data: [],
      },
      period: [],
      searchParam: {
        plantCd: '',
        deptCd: '',
        year: '',
        judgmentCd: null,
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        isFull: true,
        top: '',
        param: {},
        closeCallback: null,
      },
      saveUrl: '',
      isSave: false,
      mappingType: 'POST',
      listConsultUrl: '',
      deleteUrl: '',
      row: {
        suspectId: '',
        deptName: '',
        userName: '',
      },
      isRegister: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.listUrl = selectConfig.hea.checkup.suspect.user.list.url;
      this.saveUrl = transactionConfig.hea.checkup.suspect.user.save.url;
      this.deleteUrl = transactionConfig.hea.checkup.suspect.user.delete.url;

      this.listConsultUrl = selectConfig.hea.checkup.suspect.consult.list.url;

      this.searchParam.year = this.$comm.getThisYear();
      this.getList();
    },
    getList() {
      this.grid2.data = [];
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
        this.isRegister = false;
      },);
    },
    rowClick(item) {
      this.row.suspectId = item.suspectId;
      this.row.deptName = item.deptName;
      this.row.userName = item.userName;

      this.isRegister = true;
      this.$http.url = this.listConsultUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        suspectId: item.suspectId
      };
      this.$http.request((_result) => {
        this.grid2.data = _result.data;
      },);
    },
    detailPopup(result) {
      this.popupOptions.target = () => import(`${"./consultDetail.vue"}`);
      this.popupOptions.title = this.row.userName + '의 건강상담 상세';
      this.popupOptions.isFull = false;
      this.popupOptions.width = '95%';
      this.popupOptions.param = {
        suspectConsultId: result ? result.suspectConsultId : '',
        suspectId: this.row.suspectId,
        suspectFlag: result ? result.suspectFlag : 'Y',
        suspectUserName: this.row.deptName + ' / ' +  this.row.userName,
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeDetailPopup;
    },
    closeDetailPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.rowClick(this.row);
    },
    addSuspect() {
      this.popupOptions.target = () => import(`${"./suspectUserPop.vue"}`);
      this.popupOptions.title = '유소견자 대상 지정';
      this.popupOptions.param = {}
      this.popupOptions.width = '60%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeSuspectPopup;
    },
    closeSuspectPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    saveSuspect() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '저장하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$_.forEach(this.grid.data, _item => {
            _item.chgUserId =  this.$store.getters.user.userId;
          })
          this.isSave = !this.isSave;
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
    },
    removeSuspect() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
         window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'warning', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.deleteUrl;
            this.$http.type = 'DELETE';
            this.$http.param = {
              data: Object.values(selectData)
            }
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$set(this.$refs['table'], 'selected', [])
              this.getList();
            })
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
  }
};
</script>
